export const USER_LOCALSTORAGE_NAME = 'crestauser';
export const VALID = 'VALID';